import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapsLoader from 'google-maps';
import MapStyle from '../map.json';
import RonchiMarker from '../images/google_map_pin.png';

GoogleMapsLoader.KEY = 'AIzaSyB5bf-9X5soX3bjkzmmxXiFPDNqKFVR-Co';
GoogleMapsLoader.LANGUAGE = 'fr';
GoogleMapsLoader.REGION = 'CH';

/**
 * Map component
 */
class Map extends React.Component {
  static displayName = 'Map';
  static propTypes = {
    className: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = 'Map';

    this.state = {
      googleLoaded: false,
    };
  }

  /**
   * @override
   */
  componentDidMount() {
    GoogleMapsLoader.load(google => {
      // window.google = google;
      this.setState({googleLoaded: true});

      this.map = new google.maps.Map(this.mapElement, {
        center: {lat: 46.406743, lng: 6.260557},
        zoom: 13,
        styles: MapStyle,
      });

      this.marker = new google.maps.Marker({
        position: {lat: 46.415197, lng: 6.260198},
        map: this.map,
        zIndex: -20,
        icon: {
          url: RonchiMarker,
          anchor: new google.maps.Point(50, 100),
          scaledSize: new google.maps.Size(100, 100),
        },
      });
    });
  }

  /**
 * @override
 */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ''} ${this.state
          .googleLoaded
          ? 'is-loaded'
          : 'is-loading'}`}
        style={{height: '37rem'}}
      >
        <div
          className={`${this.className}__map`}
          style={{height: '100%'}}
          ref={map => (this.mapElement = map)}
        />
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js